(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
(function () {
  function prepare(root) {
    if (root.dataset.liftyFocusReady) return;
    root.dataset.liftyFocusReady = 'true';
    function sync() {
      root.toggleAttribute('inert', root.getAttribute('aria-hidden') === 'true');
      root.querySelectorAll('[aria-hidden]').forEach(function (element) {
        element.toggleAttribute('inert', element.getAttribute('aria-hidden') === 'true');
      });
    }
    sync();
    new MutationObserver(sync).observe(root, {subtree: true, attributes: true, attributeFilter: ['aria-hidden']});
  }
  function initialize() {
    document.querySelectorAll('.t4-section-announcement-bar').forEach(prepare);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bike-to-work-scheme"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const calculateIncomeTax = (income, standardBand) => Math.min(income, standardBand) * 0.2 + Math.max(income - standardBand, 0) * 0.4;
    const calculateUsc = (income) => {
      const bands = [[12012, 0.005], [16688, 0.02], [41344, 0.03], [Infinity, 0.08]];
      let remaining = income;
      let total = 0;
      bands.forEach(([band, rate]) => {
        const taxable = Math.min(Math.max(remaining, 0), band);
        total += taxable * rate;
        remaining -= taxable;
      });
      return total;
    };

    document.querySelectorAll('[data-btws-calculator]').forEach((calculator) => {
      if (calculator.dataset.ready === 'true') return;
      calculator.dataset.ready = 'true';
      const scheme = calculator.querySelector('[data-btws-scheme]');
      const costs = [...calculator.querySelectorAll('[data-btws-cost]')];
      const salary = calculator.querySelector('[data-btws-salary]');
      const taxProfile = calculator.querySelector('[data-btws-tax-profile]');
      const taxNote = calculator.querySelector('[data-btws-tax-note]');
      const money = new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR' });
      const output = (name) => calculator.querySelector(`[data-btws-${name}]`);
      let calculatorOpened = false;
      let calculationTracked = false;
      const track = (event, details = {}) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event, ...details });
      };

      const update = () => {
        const total = costs.reduce((sum, input) => sum + (Number.parseFloat(input.value) || 0), 0);
        const limit = Number.parseFloat(scheme.value) || 1500;
        const eligible = Math.min(total, limit);
        const annualSalary = Number.parseFloat(salary.value) || 0;
        const profile = taxProfile.value;
        const reducedSalary = Math.max(annualSalary - eligible, 0);
        const frequency = Number.parseInt(calculator.querySelector('input[name^="btws-frequency-"]:checked')?.value, 10) || 12;
        let incomeSaving;

        if (profile === 'standard') incomeSaving = eligible * 0.2;
        else if (profile === 'higher') incomeSaving = eligible * 0.4;
        else {
          const standardBand = Number.parseFloat(profile) || 44000;
          incomeSaving = calculateIncomeTax(annualSalary, standardBand) - calculateIncomeTax(reducedSalary, standardBand);
        }

        const prsi = eligible * 0.042;
        const usc = calculateUsc(annualSalary) - calculateUsc(reducedSalary);
        const saving = Math.min(eligible * 0.52, incomeSaving + prsi + usc);
        const net = total - saving;

        output('total').textContent = money.format(total);
        output('income').textContent = money.format(incomeSaving);
        output('prsi').textContent = money.format(prsi);
        output('usc').textContent = money.format(usc);
        output('saving').textContent = money.format(saving);
        output('net').textContent = money.format(net);
        output('period').textContent = money.format(net / frequency);
        output('limit').textContent = total > limit ? `${money.format(total - limit)} is above the selected tax-free scheme limit.` : `Within the ${money.format(limit)} selected scheme limit.`;
        output('status').classList.toggle('is-over', total > limit);

        if (profile === 'standard') taxNote.textContent = 'The estimate applies the 20% Income Tax rate to the eligible package.';
        else if (profile === 'higher') taxNote.textContent = 'The estimate applies the 40% Income Tax rate to the eligible package.';
        else taxNote.textContent = `The estimate uses a ${money.format(Number.parseFloat(profile))} standard-rate band for 2026.`;
      };

      [scheme, salary, taxProfile, ...costs, ...calculator.querySelectorAll('input[type="radio"]')].forEach((field) => {
        field.addEventListener('input', () => {
          update();
          if (!calculatorOpened) {
            track('bike_to_work_calculator_opened');
            calculatorOpened = true;
          }
        });
        field.addEventListener('change', () => {
          update();
          if (!calculationTracked) {
            track('bike_to_work_calculation_completed', { scheme_limit: Number.parseFloat(scheme.value) || 1500 });
            calculationTracked = true;
          }
        });
      });
      update();
    });

    document.querySelectorAll('.btws details').forEach((detail) => {
      if (detail.dataset.btwsAccordionReady === 'true') return;
      const summary = detail.querySelector(':scope > summary');
      if (!summary) return;
      detail.dataset.btwsAccordionReady = 'true';
      summary.setAttribute('aria-expanded', String(detail.open));
      detail.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(detail.open)));
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        detail.open = !detail.open;
      });
    });

    document.addEventListener('click', (event) => {
      const scrollBtn = event.target.closest('[data-btws-scroll]');
      if (scrollBtn) {
        const target = document.querySelector('[data-btws-anchor="' + scrollBtn.dataset.btwsScroll + '"]');
        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', '#' + target.id);
        }
      }
      const quoteJourney = event.target.closest('[data-btws-quote-journey]');
      if (quoteJourney) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'bike_to_work_quote_clicked', destination: quoteJourney.getAttribute('href') });
      }
      const productLink = event.target.closest('[data-btws-product-link]');
      if (productLink) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'bike_to_work_product_clicked', product_handle: productLink.dataset.productHandle });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifty-bike-to-work"]) return;
  try {
    
  (() => {
    const calculator = document.querySelector('[data-btw-calculator]');
    if (!calculator) return;
    const cost = calculator.querySelector('[data-btw-cost]');
    const rate = calculator.querySelector('[data-btw-rate]');
    const months = calculator.querySelector('[data-btw-months]');
    const saving = calculator.querySelector('[data-btw-saving]');
    const monthly = calculator.querySelector('[data-btw-monthly]');
    const money = new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR' });
    const update = () => {
      const amount = Math.max(0, Number.parseFloat(cost.value) || 0);
      const combinedRate = Math.min(.52, Math.max(0, Number.parseFloat(rate.value) || 0));
      const totalSaving = amount * combinedRate;
      saving.textContent = money.format(totalSaving);
      monthly.textContent = money.format((amount - totalSaving) / (Number.parseInt(months.value, 10) || 12));
    };
    [cost, rate, months].forEach((field) => field.addEventListener('input', update));
    [rate, months].forEach((field) => field.addEventListener('change', update));
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifty-brand-hub"] && !Shopify.designMode) return;
  try {
    
(function(){function init(){const hub=document.querySelector('[data-brand-hub]');if(!hub||hub.dataset.ready)return;hub.dataset.ready='true';if(window.matchMedia('(max-width:700px)').matches)hub.querySelectorAll('.lb-filters details').forEach(d=>d.removeAttribute('open'));const grid=hub.querySelector('.lb-grid');if(!grid)return;const cards=Array.from(grid.children),search=hub.querySelector('[data-brand-search]'),sort=hub.querySelector('[data-brand-sort]'),count=hub.querySelector('[data-current-bar]'),empty=hub.querySelector('[data-brand-empty]');function recount(){const n=cards.filter(c=>!c.classList.contains('lifty-filter-hidden')&&!c.classList.contains('lb-search-hidden')).length;if(count.textContent!==String(n))count.textContent=String(n);empty.hidden=n!==0}function applySearch(){const term=search.value.trim().toLowerCase();cards.forEach(c=>c.classList.toggle('lb-search-hidden',!c.dataset.search.includes(term)));recount()}search.addEventListener('input',applySearch);sort.addEventListener('change',()=>{const mode=sort.value;cards.slice().sort((a,b)=>mode==='price-asc'?Number(a.dataset.price)-Number(b.dataset.price):mode==='price-desc'?Number(b.dataset.price)-Number(a.dataset.price):mode==='name'?a.dataset.name.localeCompare(b.dataset.name):(Number(b.dataset.available)-Number(a.dataset.available)||Number(a.dataset.order)-Number(b.dataset.order))).forEach(c=>grid.append(c));recount()});hub.querySelectorAll('[data-lifty-filter-group] li').forEach(li=>{const group=li.closest('[data-lifty-filter-group]').dataset.liftyFilterGroup,val=li.dataset.filterVal,el=li.querySelector('.t4s-value-count');if(el)el.textContent='('+cards.filter(c=>c.classList.contains('filter-'+group+'-'+val)).length+')'});hub.querySelector('[data-brand-reset]').addEventListener('click',()=>{hub.querySelectorAll('li.is--selected a').forEach(a=>a.click());search.value='';sort.value='featured';sort.dispatchEvent(new Event('change'));applySearch()});new MutationObserver(recount).observe(grid,{subtree:true,attributes:true,attributeFilter:['class']});sort.dispatchEvent(new Event('change'));recount()}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifty-ebike-authority"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lifty-finder]').forEach((finder) => {
    const form = finder.querySelector('form');
    const result = finder.querySelector('[data-lifty-result]');
    const recommendations = {
      urban: ['City and commuter e-bikes', 'A practical starting point for everyday roads, an upright ride and commuting equipment.', '/collections/urban-electric-bikes-ireland'],
      folding: ['Folding electric bikes', 'A strong starting point when stairs, apartments, offices or a smaller stored footprint matter.', '/collections/folding-electric-bikes-ireland'],
      cargo: ['Cargo electric bikes', 'Built around carrying capacity for family journeys, business use or larger everyday loads.', '/collections/cargo-bikes-ireland'],
      mountain: ['Electric mountain bikes', 'Designed for riders prioritising trails, control and recreational mixed-terrain use.', '/collections/electric-mountain-bikes-ireland'],
      fat: ['Fat tyre electric bikes', 'Worth comparing when comfort and stability on rougher mixed surfaces matter more than low weight.', '/collections/fat-tyre-electric-bikes-ireland'],
      touring: ['Touring electric bikes', 'The best starting point for longer round trips where comfort, battery planning and luggage matter.', '/collections/touring-electric-bikes-ireland']
    };
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(form);
      let key = 'urban';
      if (data.get('use') === 'cargo' || data.get('priority') === 'capacity') key = 'cargo';
      else if (data.get('use') === 'trails') key = 'mountain';
      else if (data.get('storage') === 'apartment' || data.get('storage') === 'limited' || data.get('priority') === 'portability') key = 'folding';
      else if (data.get('distance') === 'over40' || data.get('priority') === 'range') key = 'touring';
      else if (data.get('use') === 'mixed' || data.get('priority') === 'comfort') key = 'fat';
      const choice = recommendations[key];
      const schemeLink = data.get('scheme') === 'no' ? '' : ' <a href="/pages/bike-to-work-scheme-ireland-lifty-electric">Check Bike to Work eligibility and request a quote.</a>';
      result.innerHTML = '<h3>' + choice[0] + '</h3><p>' + choice[1] + '</p><p><a href="' + choice[2] + '">Explore this collection →</a>' + schemeLink + '</p>';
      result.hidden = false;
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifty-find-my-fix"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const root=document.querySelector('#find-my-fix');
  if(!root)return;
  const copy=JSON.parse(root.querySelector('#lfx-copy').textContent);
  for(const key of Object.keys(copy))copy[key]=copy[key].replace(/&(amp|lt|gt|quot|#39|#x27);/g,(_,v)=>({amp:'&',lt:'<',gt:'>',quot:'\"','#39':"'",'#x27':"'"})[v]);
  const $=id=>root.querySelector('#lfx-'+id);
  const n=s=>String(s).toLowerCase().normalize('NFKD').replace(/[^a-z0-9]+/g,' ').trim();
  const node=(tag,text,attrs={})=>{const e=document.createElement(tag);if(text)e.textContent=text;for(const [k,v] of Object.entries(attrs))e.setAttribute(k,v);return e;};
  const base=root.dataset.root.replace(/\/$/,'');
  let data={models:[],parts:[]},selected=null,candidates=[],shown=12,currentIssue='';
  const status=text=>{$('status').textContent=text;};
  const option=(value,text)=>node('option',text,{value});
  function clearResult(){selected=null;$('results').hidden=true;}
  function brands(){clearResult();const type=$('kind').value;const prior=$('brand').value;const names=[...new Set(data.models.filter(m=>!type||m.kind===type).map(m=>m.brand))].sort();$('brand').replaceChildren(option('',copy.choose_brand),...names.map(b=>option(b,b)),option('other',copy.other));$('brand').disabled=false;if(names.includes(prior))$('brand').value=prior;models();}
  function models(){clearResult();const brand=$('brand').value,type=$('kind').value,filter=n($('model-filter').value);const prior=$('model').value;const list=data.models.map((m,i)=>({...m,index:i})).filter(m=>(!type||m.kind===type)&&m.brand===brand&&n(m.name).includes(filter));$('model').replaceChildren(option('',copy.choose_model),...list.map(m=>option(String(m.index),m.name)),option('other',copy.other));$('model').disabled=!brand;if(prior&&[...$('model').options].some(o=>o.value===prior))$('model').value=prior;if(brand==='other')$('model').value='other';custom();if(brand&&filter&&!list.length)status(copy.no_models);else status(copy.loaded);}
  function custom(){clearResult();const other=$('model').value==='other';$('custom-label').hidden=!other;$('custom').required=other;}
  function picked(){const v=$('model').value;if(!v||!$('brand').value)return null;if(v==='other'){const name=$('custom').value.trim();return name?{brand:$('brand').value,name,scope:'',aliases:[],custom:true}:null;}return data.models[Number(v)];}
  function fullWord(text,term){return (' '+n(text)+' ').includes(' '+n(term)+' ');}
  function matchesModel(p,m){
    if(m.custom)return false;
    if(m.brand==='NIU'){
      const normalized=value=>n(value).replace(/\s/g,'');
      return p.models.some(tag=>m.aliases.some(alias=>normalized(alias)===normalized(tag)||(/^kqi[0-9]+$/.test(normalized(tag))&&new RegExp('^'+normalized(tag)+'(?:pro|sport|max|p|f|x)$').test(normalized(alias)))));
    }
    let terms=[m.name,...m.aliases].map(s=>s.replace(/\b(electric|folding|foldable|scooter|scooters|bike|bikes|e-bike|ebike|unicycle)\b/gi,' ').replace(/\([^)]*\)/g,' ').trim());
    const brand=n(m.brand).replace('segway ninebot','');
    return terms.some(term=>{const clean=n(term).replace(/^segway ninebot /,'').replace(/^xiaomi /,'').replace(/^segway /,'').replace(/^ninebot /,'');if(clean.length<3)return false;const title=n(p.title);if(!fullWord(title,clean))return false;if(m.brand==='Xiaomi'&&!/xiaomi|m365/.test(title))return false;if(m.brand==='Segway Ninebot'&&!/ninebot|segway/.test(title))return false;const suffix=title.split(n(clean))[1]||'';if(/^ (pro|max|sport|plus|ultra|master|lite|mini|s|x|ii|iii)( |$)/.test(suffix)&&!/(pro|max|sport|plus|ultra|master|lite|mini|ii|iii)( |$)/.test(n(clean)))return false;return !brand||fullWord(title,brand)||fullWord(title,n(clean));});
  }
  const productCache=new Map();
  function enrichPart(a,p){
    if(!productCache.has(p.handle))productCache.set(p.handle,fetch(base+'/products/'+encodeURIComponent(p.handle)+'.js',{signal:AbortSignal.timeout(10000)}).then(r=>{if(!r.ok)throw new Error();return r.json();}));
    productCache.get(p.handle).then(product=>{if(!a.isConnected)return;const image=product.featured_image;if(image){const url=new URL(image,location.origin);if(url.protocol==='https:'){url.searchParams.set('width','360');const img=node('img','',{src:url.href,alt:product.title,width:'360',height:'220',loading:'lazy'});a.prepend(img);}}const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en-IE',{style:'currency',currency:window.Shopify?.currency?.active||'EUR'}).format(cents/100);const value=product.price_varies?money(product.price_min)+' – '+money(product.price_max):money(product.price);a.insertBefore(node('b',value,{class:'lfx-part-price'}),a.lastElementChild);}).catch(()=>{});
  }
  function renderParts(){const cat=$('category').value;const visible=candidates.filter(p=>!cat||p.cats.includes(cat));$('parts').replaceChildren();for(const p of visible.slice(0,shown)){const a=node('a','',{href:base+'/products/'+encodeURIComponent(p.handle),class:'lfx-part'});a.append(node('strong',p.title),node('span',copy.view_part+' →'));$('parts').append(a);enrichPart(a,p);}$('no-parts').hidden=visible.length>0;$('more').hidden=visible.length<=shown;}
  function run(issue=''){
    const model=picked();if(!model){status(copy.choose_first);$('form').reportValidity();return;}
    const query=$('query').value.trim();if(!query&&!issue){status(copy.enter_fault);return;}
    selected=model;currentIssue=issue;shown=12;
    const normalized=n(query),code=normalized.match(/^(?:(?:error|fault|code|e)\s*)*0*(\d{1,3})$/)?.[1];
    let article=null,category=issue;
    if(code){article=[...root.querySelectorAll('.lfx-codes [data-code]')].find(e=>e.dataset.scope===model.scope&&e.dataset.code.split(',').some(c=>Number(c)===Number(code)));category=article?.dataset.category||'';}
    else {article=issue?root.querySelector('[data-guide="'+issue+'"]'):[...root.querySelectorAll('[data-guide]')].map(e=>({e,score:e.dataset.terms.split(' ').filter(term=>term.length>2&&fullWord(normalized,term)).length})).sort((a,b)=>b.score-a.score).find(x=>x.score>0)?.e;category=article?.dataset.guide||'';}
    $('article').replaceChildren();
    if(article){const clone=article.cloneNode(true);clone.removeAttribute('id');clone.open=true;$('article').append(clone);$('result-title').textContent=article.querySelector('summary').textContent;}
    else {$('result-title').textContent=code?copy.code_unknown:copy.symptom_unknown;$('article').append(node('p',code?copy.unknown_copy:copy.symptom_copy));}
    $('context').textContent=copy.result_for+': '+model.name+' · '+query;
    const payload='Find My Fix — '+model.name+' — '+query;
    $('check').href='mailto:hello@lifty.co?subject='+encodeURIComponent(payload)+'&body='+encodeURIComponent('Vehicle: '+model.name+'\nIssue / error: '+query+'\n\nPlease confirm the fault and correct part before I order.\nI can attach photos of the model label, error and existing part.');
    candidates=code&&!article?[]:data.parts.filter(p=>matchesModel(p,model));
    $('category').value=category;
    const url=new URL(base+'/search',location.origin);url.searchParams.set('type','product');url.searchParams.set('q',model.name+' '+(category||'spare parts'));$('all-parts').href=url.pathname+url.search;
    $('results').hidden=false;renderParts();
    const share=new URL(location.href);share.searchParams.set('vehicle',model.name);share.searchParams.set('issue',query);history.replaceState(null,'',share);
    $('result-title').focus({preventScroll:true});$('results').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});status(copy.results);
  }
  $('kind').addEventListener('change',brands);$('brand').addEventListener('change',()=>{$('model-filter').value='';models();});$('model-filter').addEventListener('input',models);$('model').addEventListener('change',custom);$('custom').addEventListener('input',clearResult);$('query').addEventListener('input',clearResult);
  $('form').addEventListener('submit',e=>{e.preventDefault();run();});
  root.querySelectorAll('[data-issue]').forEach(b=>b.addEventListener('click',()=>{$('query').value=copy['guide_'+b.dataset.issue];run(b.dataset.issue);}));
  $('category').addEventListener('change',()=>{shown=12;renderParts();});$('more').addEventListener('click',()=>{shown+=12;renderParts();});
  $('received').addEventListener('change',()=>{const enabled=$('received').checked;$('book').setAttribute('aria-disabled',String(!enabled));$('book').tabIndex=enabled?0:-1;});
  $('book').addEventListener('click',e=>{if(!$('received').checked)e.preventDefault();});
  fetch(root.dataset.index,{signal:AbortSignal.timeout(12000)}).then(r=>{if(!r.ok)throw new Error();return r.json();}).then(index=>{data=index;brands();const params=new URLSearchParams(location.search),vehicle=params.get('vehicle'),issue=params.get('issue');if(vehicle){const i=data.models.findIndex(m=>m.name===vehicle);if(i>=0){$('brand').value=data.models[i].brand;models();$('model').value=String(i);custom();if(issue){$('query').value=issue.slice(0,160);run();}}}}).catch(()=>{status(copy.load_error);$('brand').disabled=false;$('brand').append(option('other',copy.other));});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-lifty"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lifty-product-section]').forEach((section) => {
    const mainImage = section.querySelector('.lifty-product-main-image');
    const thumbs = section.querySelectorAll('[data-lifty-gallery-thumb]');
    const variantSelect = section.querySelector('[data-lifty-variant-select]');
    const price = section.querySelector('[data-lifty-current-price]');
    const compare = section.querySelector('[data-lifty-compare-price]');
    const sku = section.querySelector('[data-lifty-sku]');
    const specSku = section.querySelector('[data-lifty-spec-sku]');
    const addButton = section.querySelector('[data-lifty-add-button]');
    const addText = section.dataset.addText;
    const soldText = section.dataset.soldText;
    const description = section.querySelector('.lifty-description-rte');
    const descriptionContent = section.querySelector('[data-lifty-description-content]');
    const sourceNode = section.querySelector('[data-lifty-template-source]');
    const templateRoot = sourceNode ? sourceNode.cloneNode(true) : description;
    const addonGroup = section.querySelector('[data-lifty-labs-setup]');
    const productForm = section.querySelector('.lifty-product-form');
    const btwSavings = section.querySelector('[data-lifty-btw-savings]');
    const moneyFormatter = new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR' });

    const updateBtwSavings = (retailCents) => {
      if (!btwSavings) return;
      const retail = Math.max(0, Number(retailCents || btwSavings.dataset.currentPriceCents || 0));
      const limit = Math.max(0, Number(btwSavings.dataset.schemeLimitCents || 150000));
      const eligible = Math.min(retail, limit);
      const balance = Math.max(0, retail - eligible);
      const saving = Math.floor(eligible * 0.52);
      const effective = Math.max(0, retail - saving);
      const format = (cents) => moneyFormatter.format(cents / 100);
      const retailNode = btwSavings.querySelector('[data-btw-retail]');
      const eligibleNode = btwSavings.querySelector('[data-btw-eligible]');
      const balanceNode = btwSavings.querySelector('[data-btw-balance]');
      const balanceRow = btwSavings.querySelector('[data-btw-balance-row]');
      const savingNode = btwSavings.querySelector('[data-btw-saving]');
      const effectiveNode = btwSavings.querySelector('[data-btw-effective]');
      const weeklyNode = btwSavings.querySelector('[data-btw-weekly]');
      if (retailNode) retailNode.textContent = format(retail);
      if (eligibleNode) eligibleNode.textContent = format(eligible);
      if (balanceNode) balanceNode.textContent = format(balance);
      if (balanceRow) balanceRow.hidden = balance <= 0;
      if (savingNode) savingNode.textContent = format(saving);
      if (effectiveNode) effectiveNode.textContent = format(effective);
      if (weeklyNode) weeklyNode.textContent = format(Math.round(effective / 52));
      btwSavings.dataset.currentPriceCents = String(retail);
    };

    const updateBtwVisibility = (priceCents) => {
      const quoteRoot = section.querySelector('[data-b2w-quote]');
      const eligible = quoteRoot?.dataset.markedEligible === 'true' || Number(priceCents) >= 100000;
      const quote = section.querySelector('[data-b2w-quote]');
      if (quote) {
        quote.hidden = !eligible;
        const trigger = quote.querySelector('[data-b2w-open]');
        if (trigger) trigger.disabled = !eligible;
      }
      if (btwSavings) btwSavings.hidden = !eligible;
    };
    updateBtwVisibility(btwSavings?.dataset.currentPriceCents);
    updateBtwSavings(btwSavings?.dataset.currentPriceCents);

    const btwToggle = btwSavings?.querySelector('[data-btw-toggle]');
    const btwDrawer = btwSavings?.querySelector('[data-btw-drawer]');
    if (btwToggle && btwDrawer) {
      const handleToggle = (e) => {
        if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
        if (e.type === 'keydown') e.preventDefault();
        const isOpen = !btwDrawer.hidden;
        btwDrawer.hidden = isOpen;
        btwToggle.setAttribute('aria-expanded', String(!isOpen));
        const icon = btwToggle.querySelector('.lifty-btw-drawer-icon');
        if (icon) icon.innerHTML = isOpen ? '&#9662;' : '&#9652;';
      };
      btwToggle.addEventListener('click', handleToggle);
      btwToggle.addEventListener('keydown', handleToggle);
    }

    if (variantSelect) {
      variantSelect.querySelectorAll('option').forEach((opt) => {
        if (opt.dataset.priceCents) {
          const eurFormatted = moneyFormatter.format(Number(opt.dataset.priceCents) / 100);
          opt.dataset.price = eurFormatted;
          if (opt.textContent.includes('$')) {
            opt.textContent = opt.textContent.replace(/\$[\d,]+(\.\d{2})?/, eurFormatted);
          }
        }
      });
      const currentOpt = variantSelect.options[variantSelect.selectedIndex];
      if (currentOpt && currentOpt.dataset.priceCents && price) {
        price.textContent = moneyFormatter.format(Number(currentOpt.dataset.priceCents) / 100);
      }
      section.querySelectorAll('.lifty-upsell-price, [data-lifty-sticky-price]').forEach((el) => {
        const txt = el.textContent.trim();
        if (txt.startsWith('$')) {
          const val = parseFloat(txt.replace(/[^0-9.]/g, ''));
          if (!isNaN(val)) el.textContent = moneyFormatter.format(val);
        }
      });
    }

    productForm?.addEventListener('submit', async (event) => {
      if (event.defaultPrevented || productForm.matches('[data-lifty-cowlendar]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const submitButton = productForm.querySelector('[type="submit"]');
      const originalText = submitButton?.textContent;
      const payload = {};
      new FormData(productForm).forEach((value, key) => {
        if (key.startsWith('properties[')) {
          const propKey = key.slice(11, -1);
          if (!payload.properties) payload.properties = {};
          payload.properties[propKey] = value;
        } else if (key !== 'checkout') {
          payload[key] = value;
        }
      });
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = submitButton.dataset.submittingText || 'Booking your service…';
      }
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ ...payload, sections: 'cart_data,mini_cart', sections_url: window.location.pathname })
        });
        if (!response.ok) throw new Error('Unable to add to cart');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (window.T4SThemeSP && window.T4SThemeSP.Drawer && (window.jQuery_T4NT || window.jQuery)) {
          try { window.T4SThemeSP.Drawer.opend((window.jQuery_T4NT || window.jQuery)('#t4s-mini_cart')); }
          catch (drawerError) { document.dispatchEvent(new CustomEvent('cart:refresh:opend')); }
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh:opend'));
        }
      } catch (error) {
        const status = addonGroup?.querySelector('[data-labs-status]');
        if (status) { status.textContent = addonGroup.dataset.error; status.hidden = false; }
        else window.alert(section.dataset.unavailableText || 'Unable to add to cart. Please try again.');
      } finally {
        if (submitButton) { submitButton.disabled = false; submitButton.textContent = originalText; }
      }
    }, true);

    thumbs.forEach((button) => {
      button.addEventListener('click', () => {
        thumbs.forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        if (mainImage && button.dataset.image) {
          mainImage.src = button.dataset.image;
          mainImage.removeAttribute('srcset');
        }
      });
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.options[variantSelect.selectedIndex];
        const available = option.dataset.available === 'true';
        if (price && option.dataset.priceCents) {
          price.textContent = moneyFormatter.format(Number(option.dataset.priceCents) / 100);
        } else if (price && option.dataset.price) {
          price.textContent = option.dataset.price;
        }
        updateBtwVisibility(option.dataset.priceCents);
        updateBtwSavings(option.dataset.priceCents);
        if (option.dataset.priceCents) {
          const hummMonthlyCents = Math.round(Number(option.dataset.priceCents) / 36);
          const hummMonthly = moneyFormatter.format(hummMonthlyCents / 100);
          const hummMonthlyNode = section.querySelector('[data-lifty-humm-monthly]');
          if (hummMonthlyNode) hummMonthlyNode.textContent = hummMonthly;
          const hummContainer = section.querySelector('[data-lifty-humm-container]');
          if (hummContainer) {
            const isHummEligible = Number(option.dataset.priceCents) >= 66000;
            hummContainer.hidden = !isHummEligible;
            hummContainer.setAttribute('aria-hidden', isHummEligible ? 'false' : 'true');
          }
        }
        if (compare) {
          if (option.dataset.compare) {
            compare.textContent = option.dataset.compare;
            compare.classList.remove('is-hidden');
          } else {
            compare.textContent = '';
            compare.classList.add('is-hidden');
          }
        }
        if (sku) {
          sku.textContent = option.dataset.sku || 'N/A';
        }
        if (specSku) {
          specSku.textContent = option.dataset.sku || 'N/A';
        }
        if (addButton) {
          addButton.disabled = !available;
          addButton.textContent = available ? addText : soldText;
        }
      });
    }

    section.querySelectorAll('[data-lifty-tab-link]').forEach((link) => {
      link.addEventListener('click', () => {
        section.querySelectorAll('[data-lifty-tab-link]').forEach((item) => item.classList.remove('is-active'));
        link.classList.add('is-active');
      });
    });

    const advantageStrip = section.querySelector('[data-lifty-advantage-auto]');

    const cleanText = (value) => (value || '').replace(/\s+/g, ' ').trim();
    const escapeHtml = (value) => cleanText(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
    const cardMarkup = (title, text) => {
      const heading = cleanText(title);
      const body = cleanText(text);
      if (!heading) return '';
      return `<article class="lifty-advantage-item"><b>${escapeHtml(heading)}</b>${body ? `<p>${escapeHtml(body)}</p>` : ''}</article>`;
    };
    const normaliseLabel = (label) => cleanText(label).replace(/:$/, '').toLowerCase();
    const normaliseHeading = (value) => cleanText(value).replace(/[^\w\s?]/g, '').toLowerCase();
    const isHeadingNode = (node) => node && node.nodeType === 1 && /^H[1-6]$/.test(node.tagName);
    const headingMatches = (heading, terms) => {
      const text = normaliseHeading(heading.textContent);
      return terms.some((term) => text.includes(normaliseHeading(term)));
    };
    const cleanRichContent = (container) => {
      if (!container) return container;
      container.querySelectorAll('[style]').forEach((item) => item.removeAttribute('style'));
      container.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((heading) => {
        const text = cleanText(heading.textContent);
        if (text) {
          heading.textContent = text;
        } else {
          heading.remove();
        }
      });
      container.querySelectorAll('p, li, td, th').forEach((item) => {
        if (!cleanText(item.textContent) && !item.querySelector('img, table')) {
          item.remove();
        }
      });
      container.querySelectorAll('br').forEach((item) => item.remove());
      return container;
    };
    const extractTemplateSection = (startTerms, stopTerms, includeStartHeading = false) => {
      if (!templateRoot) return null;
      const headings = Array.from(templateRoot.querySelectorAll('h1, h2, h3, h4'));
      const start = headings.find((heading) => headingMatches(heading, startTerms));
      if (!start) return null;

      const wrapper = document.createElement('div');
      if (includeStartHeading) {
        wrapper.appendChild(start.cloneNode(true));
      }

      let node = start.nextSibling;
      while (node) {
        if (isHeadingNode(node) && headingMatches(node, stopTerms)) {
          break;
        }
        wrapper.appendChild(node.cloneNode(true));
        node = node.nextSibling;
      }

      cleanRichContent(wrapper);
      return cleanText(wrapper.textContent) ? wrapper : null;
    };
    const renderRichContent = (target, content, extraClass) => {
      if (!target || !content || !cleanText(content.textContent)) return false;
      cleanRichContent(content);
      if (target.classList.contains('lifty-template-card')) {
        target.innerHTML = content.innerHTML;
      } else {
        const card = document.createElement('div');
        card.className = `lifty-template-card ${extraClass || ''}`.trim();
        card.innerHTML = content.innerHTML;
        target.innerHTML = '';
        target.appendChild(card);
      }
      return true;
    };
    const enhanceTemplateSections = () => {
      const mainStopTerms = [
        'product information',
        'technical specifications',
        'Lifty Electric waterproofing upgrades',
        'Lifty Electric upgrades',
        'why buy from lifty',
        'frequently asked questions',
        'flexible payment options',
        'what warranty',
        'need help choosing'
      ];
      const descriptionExtract = extractTemplateSection(['description'], mainStopTerms, false);
      if (descriptionExtract && cleanText(descriptionExtract.textContent).length > 60) {
        renderRichContent(descriptionContent, descriptionExtract, 'lifty-description-card');
      }

      const upgradeExtract = extractTemplateSection(
        ['Lifty Electric waterproofing upgrades', 'Lifty Electric upgrades'],
        ['why buy from lifty', 'frequently asked questions', 'flexible payment options', 'what warranty', 'need help choosing'],
        true
      );
      renderRichContent(section.querySelector('[data-lifty-upgrade-content]'), upgradeExtract, 'lifty-upgrade-rich-card');

      const faqExtract = extractTemplateSection(
        ['frequently asked questions'],
        ['flexible payment options', 'what warranty', 'need help choosing'],
        true
      );
      if (renderRichContent(section.querySelector('[data-lifty-faq-content]'), faqExtract, 'lifty-faq-rich-card')) {
        const fallbackFaq = section.querySelector('[data-lifty-faq-fallback]');
        if (fallbackFaq) fallbackFaq.hidden = true;
      }

      const whyBuyExtract = extractTemplateSection(
        ['why buy from lifty'],
        ['frequently asked questions', 'flexible payment options', 'what warranty', 'need help choosing'],
        true
      );
      renderRichContent(section.querySelector('[data-lifty-why-buy-content]'), whyBuyExtract);

      const paymentExtract = extractTemplateSection(
        ['flexible payment options'],
        ['what warranty', 'need help choosing the right ride'],
        true
      );
      renderRichContent(section.querySelector('[data-lifty-payment-content]'), paymentExtract);

      const warrantyExtract = extractTemplateSection(
        ['what warranty does this product include', 'what warranty'],
        ['need help choosing the right ride'],
        true
      );
      renderRichContent(section.querySelector('[data-lifty-warranty-content]'), warrantyExtract);
    };
    const displayLabel = (label) => {
      const normal = normaliseLabel(label);
      if (normal.includes('motor')) return 'Motor performance';
      if (normal.includes('battery capacity') || normal === 'battery') return 'Battery';
      if (normal.includes('battery energy')) return 'Battery energy';
      if (normal.includes('range')) return 'Riding range';
      if (normal.includes('speed')) return 'Speed capability';
      if (normal.includes('tyre') || normal.includes('tire')) return 'Tyres';
      if (normal.includes('suspension')) return 'Suspension comfort';
      if (normal.includes('brak')) return 'Braking control';
      if (normal.includes('water') || normal.includes('ip rating') || normal.includes('ipx')) return 'Weather protection';
      if (normal.includes('display')) return 'Display';
      if (normal.includes('frame') || normal.includes('material')) return 'Build quality';
      if (normal.includes('compatib')) return 'Compatibility';
      if (normal.includes('weight')) return 'Weight';
      if (normal.includes('size') || normal.includes('dimension')) return 'Sizing';
      if (normal.includes('voltage')) return 'Voltage';
      if (normal.includes('power')) return 'Power';
      return cleanText(label);
    };

    const buildFromDescriptionAdvantages = () => {
      if (!templateRoot) return [];
      const headings = Array.from(templateRoot.querySelectorAll('h1, h2, h3'));
      const advantageHeading = headings.find((heading) => /advantages of/i.test(heading.textContent || ''));
      if (!advantageHeading) return [];

      let node = advantageHeading.nextElementSibling;
      while (node && node.tagName !== 'UL') {
        if (/^H[1-6]$/.test(node.tagName)) return [];
        node = node.nextElementSibling;
      }

      if (!node) return [];
      return Array.from(node.querySelectorAll('li'))
        .map((item) => cleanText(item.textContent))
        .filter(Boolean)
        .slice(0, 4)
        .map((text) => ({ title: text, text: '' }));
    };

    const buildFromSpecificationTables = () => {
      if (!templateRoot) return [];
      const priority = [
        'motor rated power',
        'motor',
        'battery capacity',
        'battery',
        'battery energy',
        'maximum range',
        'range',
        'peak power',
        'top speed',
        'maximum unlocked speed',
        'tyres',
        'tires',
        'suspension',
        'braking system',
        'brakes',
        'water resistance',
        'ip rating',
        'display',
        'frame material',
        'compatibility',
        'size',
        'material',
        'voltage',
        'power'
      ];
      const rows = Array.from(templateRoot.querySelectorAll('tr'));
      const specs = rows.map((row) => {
        const cells = Array.from(row.querySelectorAll('th, td')).map((cell) => cleanText(cell.textContent));
        return { label: cells[0], value: cells[1] };
      }).filter((item) => item.label && item.value && item.label.toLowerCase() !== 'specification' && item.label.toLowerCase() !== 'details');

      const cards = [];
      const used = new Set();
      priority.forEach((key) => {
        const match = specs.find((item) => {
          const label = normaliseLabel(item.label);
          return !used.has(label) && label.includes(key);
        });
        if (match && cards.length < 4) {
          used.add(normaliseLabel(match.label));
          cards.push({ title: displayLabel(match.label), text: match.value });
        }
      });

      return cards;
    };

    const buildFallbackCards = () => {
      if (!advantageStrip) return [];
      const title = cleanText(advantageStrip.dataset.productTitle);
      const vendor = cleanText(advantageStrip.dataset.productVendor) || 'Lifty';
      const type = cleanText(advantageStrip.dataset.productType) || 'Product';
      const lowerType = type.toLowerCase();
      const lowerContext = `${lowerType} ${title.toLowerCase()}`;

      if (lowerContext.includes('tyre') || lowerContext.includes('tire') || lowerContext.includes('inner tube')) {
        return [
          { title: 'Correct fitment support', text: 'Check the printed size and wheel compatibility before ordering.' },
          { title: 'Maintenance-ready part', text: 'Useful for puncture repairs, servicing and everyday mobility upkeep.' },
          { title: 'Clear size information', text: title },
          { title: 'Lifty compatibility help', text: 'Ask us before purchase if you are unsure about fitment.' }
        ];
      }

      if (lowerContext.includes('charger')) {
        return [
          { title: 'Charging support', text: 'Selected to help keep compatible rides powered and ready.' },
          { title: 'Compatibility matters', text: 'Check voltage, connector and model suitability before ordering.' },
          { title: 'Practical replacement', text: 'Useful as a replacement or spare charging setup.' },
          { title: 'Lifty guidance', text: 'Ask us before purchase if you are unsure about fitment.' }
        ];
      }

      if (lowerContext.includes('part') || lowerContext.includes('spare')) {
        return [
          { title: 'Repair-focused replacement', text: title },
          { title: 'Compatibility matters', text: 'Check model, size, connector or voltage before ordering.' },
          { title: 'Workshop-informed support', text: 'Lifty can help confirm suitability where possible.' },
          { title: 'Clear ordering details', text: 'Useful for riders replacing worn or damaged components.' }
        ];
      }

      if (lowerContext.includes('repair') || lowerContext.includes('service')) {
        return [
          { title: 'Dublin workshop support', text: 'Handled by an electric mobility team with practical repair experience.' },
          { title: 'Built for real riders', text: 'Ideal when your scooter, e-bike or EUC needs attention.' },
          { title: 'Clear service guidance', text: 'We help explain the work needed before you commit.' },
          { title: 'After-sales support', text: 'Helpful advice before and after your workshop booking.' }
        ];
      }

      return [
        { title: vendor, text: 'A clear brand reference for riders comparing options confidently.' },
        { title: type, text: 'Selected for riders looking for the right fit, performance and support.' },
        { title: 'Why it stands out', text: title },
        { title: 'Lifty support', text: 'Ask us for product, compatibility, upgrade and warranty guidance.' }
      ];
    };

    enhanceTemplateSections();

    if (advantageStrip) {
      const existingSpecificCards = Array.from(advantageStrip.querySelectorAll('.lifty-advantage-item b'))
        .map((item) => cleanText(item.textContent))
        .filter(Boolean);
      const existingLooksGeneric = existingSpecificCards.some((text) => /lifty support|why it stands out|selected for riders|clear brand reference|clear ordering details/i.test(text));
      const cards = buildFromDescriptionAdvantages();
      const specCards = cards.length >= 3 ? cards : buildFromSpecificationTables();
      const finalCards = specCards.length >= 3 ? specCards : buildFallbackCards();
      const whyCustomers = section.querySelector('[data-lifty-why-customers]');
      const productTitle = cleanText(advantageStrip.dataset.productTitle);
      const cardReason = (card) => {
        const cardTitle = cleanText(card && card.title);
        const cardText = cleanText(card && card.text);
        if (cardText && cardText.toLowerCase() !== productTitle.toLowerCase() && !/[.!?]$/.test(cardText)) return cardText;
        return cardTitle;
      };

      if (finalCards.length >= 3 && (existingLooksGeneric || cards.length > 0 || specCards.length > 0)) {
        advantageStrip.innerHTML = finalCards.slice(0, 4).map((card) => cardMarkup(card.title, card.text)).join('');
      }
      if (whyCustomers && finalCards.length >= 2) {
        const firstReason = cardReason(finalCards[0]);
        const secondReason = cardReason(finalCards[1]);
        const thirdReason = cardReason(finalCards[2]);
        if (productTitle && firstReason && secondReason) {
          let reasonText = `${firstReason} and ${secondReason}`;
          if (thirdReason && !/lifty support/i.test(thirdReason)) {
            reasonText = `${firstReason}, ${secondReason} and ${thirdReason}`;
          }
          whyCustomers.textContent = `The ${productTitle} stands out for ${reasonText}. Backed by expert advice, trusted after-sales support and clear product information from Lifty Electric, you can buy with confidence.`;
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
